import { NgModule }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';

import { CalendarsComponent } from './calendars.component';
import { CalendarMetadataComponent } from './calendar-metadata/calendar-metadata.component';
import { CalendarMetadataEditorComponent } from './calendar-metadata-editor/calendar-metadata-editor.component';

import { AngularMaterialModule } from '../angular-material.module';

//import { DynamicFormModule } from '../dynamic-form/dynamic-form.module';

import { CalendarService } from '../services/calendar-service/calendar.service';

@NgModule({
  imports:      [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    //DynamicFormModule,
  ],
  declarations: [
    CalendarsComponent,
    CalendarMetadataComponent,
    CalendarMetadataEditorComponent,
  ],
  exports:      [ CalendarsComponent ],
  providers:    [ CalendarService ]
})
export class CalendarsModule { }
